import { Component, Input, OnInit } from '@angular/core';
import { BaseReportCardComponent } from '../base-report-card.component';
import { Chart } from 'chart.js';
import { ReportGenSvc, WorkAverageRequest } from 'src/app/services_autogenerated/generated_services';
import { RmDateRangeServiceService } from 'src/app/services/rm-date-range-service.service';

@Component({
    selector: 'app-work-hour-average',
    templateUrl: './work-hour-average.component.html',
    styleUrls: ['./work-hour-average.component.css'],
    standalone: false
})
export class WorkHourAverageComponent extends BaseReportCardComponent implements OnInit {
  @Input() wellnessGoal: number;
  @Input() workGoal: number;

  averageLoading: boolean = true;

  constructor(private reportService: ReportGenSvc,
    private rmDashboardDateRangeService: RmDateRangeServiceService) {
    super();
  }

  ngOnInit() {
    this.rmDashboardDateRangeService.getDateRangeUpdater().subscribe(changed => {
      this.averageLoading = true;
      this.startDate = changed.start;
      this.endDate = changed.end;
      
      const goalPointer = {
        id: 'goalPointer',
        afterDatasetsDraw: function (chart, args, plugins) {
          const {ctx, data} = chart;
          ctx.save();

          const xCenter = chart.getDatasetMeta(0).data[0]._view.x; 
          const yCenter = chart.getDatasetMeta(0).data[0]._view.y; 
          const innerRadius = chart.getDatasetMeta(0).data[0]._view.innerRadius;
          const outerRadius = chart.getDatasetMeta(0).data[0]._view.outerRadius;
          const doughnutThickness = outerRadius - innerRadius;

          const pointerGoal = plugins.pointerTarget || this.workGoal;
          const color = plugins.color || 'black';
          const title = plugins.title || '';
          const angle = Math.PI / 180;

          function sumArray(arr) {
            return arr.reduce((acc, curr) => acc + curr, 0);
          }

          const dataPointArray = data.datasets[0].data.map((datapoint) => {
            return datapoint;
          })

          const totalSum = sumArray(dataPointArray);
          const targetPointerRotation = (pointerGoal / totalSum * 180) - 90;
          const datapoint = data.datasets[0].data[0];

          // average text
          ctx.font = `bold ${(innerRadius / 2 - 5)}px sans-serif`;
          ctx.fillStyle = color;
          ctx.textAlign = 'center';
          ctx.baseline = 'middle';
          ctx.fillText(`$${datapoint.toFixed(2)}/hr`, xCenter, yCenter);

          // title text
          ctx.font = 'bold 20px sans-serif';
          ctx.fillStyle = 'rgb(35,35,35)';
          ctx.textAlign = 'center';
          ctx.baseline = 'middle';
          ctx.fillText(`${title}`, xCenter, yCenter + 20);

          // goal line
          ctx.translate(xCenter, yCenter);
          ctx.rotate(angle * targetPointerRotation)
          ctx.beginPath();
          ctx.fillStyle = 'rgb(35,35,35)';
          ctx.roundRect(0, -outerRadius - 10, 5, doughnutThickness + 10, 1);
          ctx.fill();

          // goal text
          ctx.font = 'normal 14px sans-serif';
          ctx.fillStyle = 'rgb(35,35,35)';
          ctx.textAlign = 'center';
          ctx.baseline = 'middle';
          ctx.fillText(`GOAL $${pointerGoal}`, 0, -outerRadius - 20);

          ctx.restore();
        }
      }

      this.setUpWorkAvg(goalPointer);
      this.setUpWellnessAvg(goalPointer);
    })
  }

  setUpWorkAvg(goalPointer) {
    this.reportService.getWorkAverage(new WorkAverageRequest({
      representativeId: !this.companyWide ? this.employee.id : null,
      afterDate: this.startDate,
      beforeDate: this.endDate,
      type: 'Work'
    })).subscribe(res => {
      this.averageLoading = false;
      const workTotal =  res.workHourAverage;
      const workOptions: Chart = {
        type: 'doughnut',
        data: {
          datasets: [{
            data: [workTotal, (this.workGoal + 50 - workTotal < 0 ? 0 : this.workGoal + 50 - workTotal)],
            backgroundColor: ["rgb(99,115,86)", "rgb(169,169,169)"]
          }
        ]
        },
        options: {
          legend: {
            display: false
          },
          rotation: -1.0 * Math.PI, // start angle in degrees
          circumference: Math.PI, // sweep angle in degrees
          events: [],
          title: {
            display: false
          },
          layout: {
            padding: {
              left: 30,
              right: 30,
              top: 0,
              bottom: 30
            }
          },
          plugins: {
            goalPointer: {
              pointerTarget: this.workGoal,
              color: 'rgb(99,115,86)',
              title: 'Tree Work Avg'
            }
          },
        },
        plugins: [goalPointer],
      };
      
      var canvas = <HTMLCanvasElement>document.getElementById('chartWorkJSContainer')
      var ctx = canvas.getContext('2d');
      new Chart(ctx, workOptions);
    });
  }

  setUpWellnessAvg(goalPointer) {
    this.reportService.getWorkAverage(new WorkAverageRequest({
      representativeId: !this.companyWide ? this.employee.id : null,
      afterDate: this.startDate,
      beforeDate: this.endDate,
      type: 'Wellness'
    })).subscribe(res => {
      this.averageLoading = false;
      const wellnessTotal = res.workHourAverage;
      const wellnessOptions = {
        type: 'doughnut',
        data: {
          datasets: [{
            data: [wellnessTotal, (this.wellnessGoal + 50 - wellnessTotal < 0 ? 0 : this.wellnessGoal + 50 - wellnessTotal)],
            backgroundColor: ["rgb(210,137,183)", "rgb(169,169,169)"]
          }]
        },
        options: {
          legend: {
            display: false
          },
          rotation: -1.0 * Math.PI, // start angle in degrees
          circumference: Math.PI, // sweep angle in degrees
          events: [],
          title: {
            display: false
          },
          layout: {
            padding: {
              left: 30,
              right: 30,
              top: 0,
              bottom: 30
            }
          },
          plugins: {
            goalPointer: {
              pointerTarget: this.wellnessGoal,
              color: "rgb(210,137,183)",
              title: 'Tree Wellness Avg'
            }
          },
        },
        plugins: [goalPointer],
      }

      var canvas = <HTMLCanvasElement>document.getElementById('chartWellnessJSContainer')
      var ctx = canvas.getContext('2d');
      new Chart(ctx, wellnessOptions); 
    });
  }
}
